import { getSiteBrand } from "@/lib/siteHosts";

const brandName = () => getSiteBrand().name;

export const LEAKED_LEAD_THESIS = {
  headline: "The Anatomy of a Leaked Lead",
  subline:
    "This isn't a sales pitch. It's simple mathematics. The scenario below applies to any high-intent local niche (home services, medical, legal, and more). When your campaigns drive an after-hours click at 11:15 PM, you have exactly 5 minutes before that budget is permanently burned.",
};

export const siteAHeader = () => `Site A: Your Client's Website (No ${brandName()})`;

export const siteBHeader = () => `Site B: The Competitor (Powered by ${brandName()})`;

export const SITE_A_STEPS = [
  {
    time: "11:15 PM",
    title: "Inbound Signal",
    body: "A high-intent prospect hits the landing page from your Google Ads campaign. Urgent need. Ready to buy now.",
  },
  {
    time: "11:16 PM",
    title: "The Lead Form Slips",
    body: "Lead fills out the form. Data hits the CRM. Notification pings the client's phone. The client is asleep.",
  },
  {
    time: "11:21 PM",
    title: "The 5-Minute Decay Gate",
    body: 'The lead waits. No response. Ad spend is officially burned. The prospect hits the "Back" button on Google and clicks the next local provider in the same category.',
    highlight: true,
  },
];

export const SITE_B_STEPS = [
  {
    time: "11:22 PM",
    title: "The Intercept",
    body: "The prospect lands on the competitor's page. Submits the same urgent request.",
  },
  {
    time: "11:22 PM (+9 Seconds)",
    title: "CRM Lock",
    get body() {
      return `${brandName()} infrastructure intercepts the signal. Instantly greets the user, validates location, and runs niche policy checks.`;
    },
  },
  {
    time: "11:24 PM",
    title: "Deal Secured",
    body: "Conversation complete. Qualifying details and media logged. Appointment booked for Monday 9:00 AM.",
    highlight: true,
  },
];

export const LEAKED_LEAD_CLOSING = {
  headline: "The Lead Didn't Vanish. It Just Shifted to the Fastest Node.",
  body: "Every weekend and evening, up to 40% of your generated traffic hits this exact loop. Roofing, clinics, law firms, agencies: the niche changes. The math doesn't. If your client's CRM is silent, that intent shifts to whichever business in the category answers first.",
  agencyMirror:
    "Your client won't say the CRM was slow. They'll say your leads were bad. Then they'll start shopping for a new agency.",
  get partnerExit() {
    return `You don't have to be the victim. Partner with ${brandName()} and intercept the loop for your own book.`;
  },
};

export const MOBILE_DIVIDER = "Meanwhile, on the competitor's site…";
